import { defineMessages } from "react-intl";

const messages = defineMessages({
    viewShared: {
        id: "planCard.viewShared",
    },
    viewListed: {
        id: "planCard.viewListed",
    },
});

export default messages;
